import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { GetSubjectById, AddSubject } from '../services/isubjectservice';
import slugify from 'slugify';

function SubjectNew() {
    const [name, setName] = useState("");
    const [slug, setSlug] = useState('');
    const [pk, setPk] = useState(0);
    let navigate = useNavigate();  
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // Extract query parameters
    const id = queryParams.get('pk') || null; // e.g., ?id=18
    
    useEffect(() => {
        if(id != null)
            {
                fillData (id);
                setPk(id);
            }
    }, []); 

    const handleNameChange = (event) => {
            setName(event.target.value);
            setSlug(slugify(event.target.value, { lower: true, strict:true }));
          };
    const fillData  = async (id) => {
        try {
            const subDetail = await GetSubjectById(id);
            const jsonData = JSON.parse(subDetail);
            setName(jsonData.name);
            setSlug(jsonData.paramlink);     
          } catch (error) {
            console.error('Error fetching the data:', error);
          }
    }

    const handleSave = async () => {
        try {
            const response = AddSubject(
                JSON.stringify({
                    Pk: pk,
                    Name: name,
                    Paramlink: slug,
                }));

            if(pk == 0)
                navigate('/subject', { state: { successMessage: 'New subject added' } });
            else
                navigate('/subject', { state: { successMessage: 'Subject updated' } });

        } catch (error) {
            console.error('Error fetching the data:', error);
        }
    }

    const handleCancel = async () => {
        navigate('/subject/');
    }

    return (
        <>
            <div class="row">
                <div class="col-md-6 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title">Add new subject</h4>
                            
                            <form class="forms-sample">
                                <div class="form-group">
                                    <label for="txtName">Name</label>
                                    <input type="text" class="form-control" id="txtName" onChange={handleNameChange} placeholder="Name" value={name}/>
                                </div>

                                <div class="form-group">
                                    <label for="txtParamLink">Param Link</label>
                                    <input type="text" class="form-control" id="txtParamLink" placeholder="Param Link" value={slug} />
                                </div>
                               
                                <button type="button" class="btn btn-primary me-2" onClick={() => handleSave() }>Submit</button>
                                <button class="btn btn-light" onClick={() => handleCancel() }>Cancel</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SubjectNew;
